export default __webpack_public_path__ + "static/media/logo.a4a33d30.png";